import PartnerService from '../../services/Partner.service';
import WidgetService from '../../services/Widgetv2.service';
import PagehitService from '../../services/PageHit.service';
import URLService from '../../services/HTTP.service';

class WidgetControllerService {
	setModel(model) {
		this.model = model;
		this.model.state = {
			resorts: [],
			selectedResort: '',
			dateStart: '',
			dateEnd: '',
			isValid: false,
			impressionId: null,
		};
	}
	async refresh() {
		this.data = await WidgetService.getWidgetData();
		const { partnerId } = await PartnerService.getPartnerId();
		const resorts = this.data.resorts.map(resort => ({ id: resort._id, name: resort.name }));
		this.model.setState({ resorts, partnerId });

		this.refreshImpressionId();
	}
	async refreshImpressionId() {
		const { partnerId } = await PartnerService.getPartnerId();
		if (partnerId !== PartnerService.NO_PARTNER && URLService.isLive()){
			const impressionId = await PagehitService.getPageHitId(partnerId);
			this.model.setState({ impressionId });
		} else {
			this.model.setState({ impressionId: null });
		}
	}
	onChange(e) {
		const action = { [e.target.name]: e.target.value };
		this.model.setState(action);
	}
	gotoSkiBro(e) {
		e.preventDefault();
		WidgetService.gotoSkiBro(this.model.state);

		// when the user has gone to skibro website, we must refresh the partnerRequestId.
		setTimeout(() => {
			this.refreshImpressionId();
		}, 1000);
	}
}

const widgetControllerService = new WidgetControllerService();

export default widgetControllerService;


// WEBPACK FOOTER //
// ./src/components/widgetv2/WidgetControllerService.js